import {
    Button,
    ModalBody,
    ModalDialog,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from '@flos/react-ui';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useCreateActivityHook } from '../../../hooks/useCreateActivity';
import { useHippoText } from '../../../hooks/useHippoText';
import { accountHolderAtom } from '../../../recoil/atoms/accountHolderAtom';
import { convertDateToLocalDateDTO } from '../../../utils/dateUtil';

const DifferentPolicyHolderModal = ({
    isOpen,
    closeModal
}: {
    isOpen: boolean;
    closeModal: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { createActivity } = useCreateActivityHook();
    const accountHolderDetail = useRecoilValue(accountHolderAtom);
    const [isPendingRequest, setIsPendingRequest] = useState(false);

    const createActivityAndCloseModal = async (): Promise<void> => {
        setIsPendingRequest(true);
        await createActivity({
            activityCode: 'dss_edi_different_policy_holder',
            phoneNumber: accountHolderDetail.phoneNumber,
            targetDate: convertDateToLocalDateDTO(new Date())
        });
        setIsPendingRequest(false);
        closeModal();
        window.location.href = '/';
    };

    return (
        <ModalOverlay isOpen={isOpen} onDismiss={closeModal}>
            <ModalDialog closeIconHandler={closeModal}>
                <ModalHeader title={getHippoText('DSS-DIFFERENT-POLICY-HOLDER-MODAL-TITLE')} />

                <ModalBody>
                    {getHippoText('DSS-DIFFERENT-POLICY-HOLDER-MODAL-DESCRIPTION')}
                </ModalBody>

                <ModalFooter>
                    <Button
                        onClick={() => {
                            void createActivityAndCloseModal();
                        }}
                        isLoading={isPendingRequest}
                    >
                        {getHippoText('DSS-DIFFERENT-POLICY-HOLDER-MODAL-BUTTON')}
                    </Button>
                </ModalFooter>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default DifferentPolicyHolderModal;
